import anime from "animejs/lib/anime.es.js";

// Overlay animation settings
const OVERLAY_FADE_DURATION = 400; // Duration for overlay fade in/out animations (ms)
const OVERLAY_FADE_EASING = "easeOutQuad"; // Easing function for overlay animations

// Overlay background alpha values
const OVERLAY_BACKGROUND_ALPHA = 0.5; // Background overlay opacity (0-1)
const OVERLAY_BACKGROUND_COLOR = 0x000000; // Background overlay color (black)

/**
 * Shared overlay controller for managing background overlay fade animations
 * Provides unified fade in/out behavior across all dialog components
 */
class OverlayController {
  constructor(overlayRef, setBackgroundAlpha, fadeDuration = null) {
    this.overlayRef = overlayRef;
    this.setBackgroundAlpha = setBackgroundAlpha;
    this.fadeDuration = fadeDuration || OVERLAY_FADE_DURATION;
  }

  /**
   * Fade in background overlay to configured opacity
   * @param {Function} callback - Optional callback when animation completes
   */
  fadeInBackground(callback) {
    if (this.setBackgroundAlpha) {
      anime({
        targets: { alpha: 0 },
        alpha: OVERLAY_BACKGROUND_ALPHA,
        duration: this.fadeDuration,
        easing: OVERLAY_FADE_EASING,
        update: (anim) => {
          this.setBackgroundAlpha(anim.animations[0].currentValue);
        },
        complete: () => {
          if (callback && typeof callback === "function") callback();
        },
      });
    } else if (callback && typeof callback === "function") {
      // If no setBackgroundAlpha, call callback immediately
      callback();
    }
  }

  /**
   * Fade out background overlay from configured opacity to 0
   * @param {Function} callback - Optional callback when animation completes
   */
  fadeOutBackground(callback) {
    if (this.setBackgroundAlpha) {
      // Create an animation target that starts from current alpha
      const animationTarget = { alpha: OVERLAY_BACKGROUND_ALPHA };

      anime({
        targets: animationTarget,
        alpha: 0,
        duration: this.fadeDuration,
        easing: OVERLAY_FADE_EASING,
        update: (anim) => {
          this.setBackgroundAlpha(anim.animations[0].currentValue);
        },
        complete: () => {
          // Ensure final alpha is set to 0
          this.setBackgroundAlpha(0);
          if (callback && typeof callback === "function") {
            callback();
          }
        },
      });
    } else if (callback && typeof callback === "function") {
      // If no setBackgroundAlpha, call callback immediately
      callback();
    }
  }
}

export { OVERLAY_BACKGROUND_ALPHA, OVERLAY_BACKGROUND_COLOR };
export default OverlayController;
